import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon'

export const ArrowDown = Styled(
	createSvgIcon(
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M19.92 8.94995L13.4 15.47C12.63 16.24 11.37 16.24 10.6 15.47L4.07996 8.94995"
				stroke="currentColor"
				stroke-width="2.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>,
		'ArrowDown'
	)
)

export default ArrowDown
